<template>
    <Dialog modal header="Valoraciones AXA" :style="{width: '800px'}">
        <div>
            <div v-if="cargandoCreados">
                <div class="loading-spinner">
                    <i class="fas fa-spinner fa-spin"></i> Cargando...
                </div>
            </div>  
            <div v-else-if="enviando">
                <div class="loading-spinner">
                    <i class="fas fa-spinner fa-spin"></i> Enviando...
                </div>
            </div>     
            <div v-else-if="gruposAfectadosValoracionesCreadas.length == 0">
                No hay valoraciones creadas
            </div>
            <div v-else>
                <div style="margin-top: 20px; display: grid; gap: 20px;"> 
                    <div v-for="grupoAfectado in gruposAfectadosValoracionesCreadas" :key="grupoAfectado.idAfectado" class="card card-primary">
                        <div class="card-header">
                            {{ grupoAfectado.afectado }}
                        </div>
                        <div class="card-body">
                            <div class="card card-secondary" v-for="valoracion in grupoAfectado.valoracionesCreadas" :key="valoracion">
                                <div class="card-header">
                                    <div style="display: flex; justify-content: space-between">
                                        <h5 class="card-title">
                                            Nº:{{ valoracion.id_valoracion }}-{{ valoracion.version }} Importe: {{ valoracion.total }}€ Estado: {{ valoracion.estado }}
                                        </h5>
                                        <div style="display: flex;gap: 5px;">
                                            <button class="btn btn-tool ampliar-asegurado" v-on:click="valVisible[valoracion.id_valoracion] = !valVisible[valoracion.id_valoracion]" v-if="!valVisible[valoracion.id_valoracion]">
                                                <i class="fas fa-plus"></i>
                                            </button>
                                            <button class="btn btn-tool reducir-asegurado" v-on:click="valVisible[valoracion.id_valoracion] = !valVisible[valoracion.id_valoracion]" v-if="valVisible[valoracion.id_valoracion]">
                                                <i class="fas fa-minus"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body" v-if="valVisible[valoracion.id_valoracion] == true">
                                    <div style="display: flex; justify-content: end;gap: 10px; margin-bottom: 10px;">                                        
                                        <button disabled title="Para facturar ir a la pestaña del servicio de facturación" @click="confirmarAccionValoracion(grupoAfectado, valoracion, 'FACTURAR')" v-if="valoracion.id_estado == 2" class="btn btn-sm btn-light" style="border: 1px solid grey;">
                                            Facturar
                                        </button>
                                        <button @click="confirmarAccionValoracion(grupoAfectado, valoracion, 'GEN_FACTURA')" class="btn btn-sm btn-light" style="border: 1px solid grey;" v-if="valoracion.id_estado == 4">
                                            Generar factura
                                        </button>
                                    </div>
                                    <div v-for="especialidad in valoracion.especialidades" :key="especialidad" class="card">
                                        <div class="card-header">
                                            <div style="display: flex; justify-content: space-between;">
                                                <h6 class="card-title">
                                                    {{ especialidad.especialidad }} - Presupuestar por: {{ especialidad.presupuestarPor }}                                                                                  
                                                </h6>
                                            </div>                                  
                                        </div>
                                        <div v-if="especialidad.trabajos.length == 0 && especialidad.materiales.length == 0" class="card-body">
                                            No hay trabajos ni materiales
                                        </div>
                                        <div v-else class="card-body">
                                            <div style="display: grid; gap: 15px">                                    
                                                <div>
                                                    <label for="">Trabajos</label>
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Categoria
                                                                </th>
                                                                <th>
                                                                    Linea
                                                                </th>
                                                                <th>
                                                                    Uds
                                                                </th>
                                                                <th>
                                                                    Precio
                                                                </th>
                                                                <th>
                                                                    IVA (%)
                                                                </th>
                                                                <th>
                                                                    Total
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="trabajo in especialidad.trabajos" :key="trabajo">
                                                                <td>
                                                                    {{ trabajo.trabajo.nombre_categoria }}
                                                                </td>
                                                                <td>
                                                                    {{ trabajo.trabajo.desc_linea }}
                                                                </td>
                                                                <td>
                                                                    {{ trabajo.Cantidad }}
                                                                </td>
                                                                <td>
                                                                    {{ trabajo.TotalSinIva }}
                                                                </td>
                                                                <td>
                                                                    {{ trabajo.IvaSeleccionado }}
                                                                </td>
                                                                <td>
                                                                    {{ trabajo.TotalConIva }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div>
                                                    <label for="">Materiales</label>
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Categoria
                                                                </th>
                                                                <th>
                                                                    Linea
                                                                </th>
                                                                <th>
                                                                    Uds
                                                                </th>
                                                                <th>
                                                                    Precio
                                                                </th>
                                                                <th>
                                                                    IVA (%)
                                                                </th>
                                                                <th>
                                                                    Total
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="material in especialidad.materiales" :key="material">
                                                                <td>
                                                                    {{ material.trabajo.nombre_categoria }}
                                                                </td>
                                                                <td>
                                                                    {{ material.trabajo.desc_linea }}
                                                                </td>
                                                                <td>
                                                                    {{ material.Cantidad }}
                                                                </td>
                                                                <td>
                                                                    {{ material.trabajo.precioUnidad }}
                                                                </td>
                                                                <td>
                                                                    {{ material.IvaSeleccionado }}
                                                                </td>
                                                                <td>
                                                                    {{ material.TotalConIva }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div v-if="especialidad.presupuestarPor == 'M.O.'">
                                                    <label for="">Desplazamiento</label>
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Kms
                                                                </th>
                                                                <th>
                                                                    Mínimo
                                                                </th>
                                                                <th>
                                                                    Kms netos
                                                                </th>
                                                                <th>
                                                                    Precio
                                                                </th>
                                                                <th>
                                                                    IVA (%)
                                                                </th>
                                                                <th>
                                                                    Total
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="desplazamiento in especialidad.desplazamiento" :key="desplazamiento">
                                                                <td>
                                                                    {{ desplazamiento.Cantidad }}
                                                                </td>
                                                                <td>
                                                                    {{ desplazamiento.trabajo.minKmFacturables }}
                                                                </td>
                                                                <td>
                                                                    {{ desplazamiento.trabajo.unidadesAFacturar }}
                                                                </td>
                                                                <td>
                                                                    {{ desplazamiento.trabajo.precio }}
                                                                </td>
                                                                <td>
                                                                    {{ desplazamiento.IvaSeleccionado }}
                                                                </td>
                                                                <td>
                                                                    {{ desplazamiento.TotalConIva }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div style="margin: 15px 0;">
                                                    <label for="">TOTAL OFICIO</label>
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Baremo
                                                                </th>
                                                                <th>
                                                                    MATS.
                                                                </th>
                                                                <th>
                                                                    IVA(€)
                                                                </th>
                                                                <th>
                                                                    TOTAL
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    {{ especialidad.totalBaremo }}
                                                                </td>
                                                                <td>
                                                                    {{ especialidad.totalMateriales }}
                                                                </td>
                                                                <td>
                                                                    {{ especialidad.totalIva }}
                                                                </td>
                                                                <td>
                                                                    {{ especialidad.total }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div> 
                                                <div>
                                                    <label for="">Comentario</label>
                                                    <textarea readonly v-model="especialidad.comentario" rows="2" class="form-control" id=""></textarea>
                                                </div>
                                            </div>                                
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer" v-if="valVisible[valoracion.id_valoracion] == true">
                                    <label>Resumen valoración</label>
                                    <div style="display: flex; gap: 25px; margin-top: 15px">
                                        <div style="display: grid; grid-template-columns: 2fr 1fr; align-items: center">
                                            <span style="margin: 0;" for="">Total a liquidar reparador</span>
                                            <input type="text" class="form-control" readonly :value="valoracion.liquidar_reparador">
                                        </div>
                                        <div style="display: grid; grid-template-columns: 2fr 1fr; align-items: center">
                                            <span style="margin: 0;" for="">Total a liquidar cliente</span>
                                            <input type="text" class="form-control" readonly :value="valoracion.liquidar_cliente">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                       
                </div>               
            </div>
            <div style="display: flex; border-top: 1px solid grey; margin-top: 10px; justify-content: end;">
                <button class="btn btn-light btn-sm" style="border: 1px solid; margin-top: 15px;" @click="$emit('cerrar')">Cerrar</button>
            </div>  
        </div>
    </Dialog>    
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: ['id', 'oficios'],
    components: {
    },
    data() {
        return {
            enviando:false,
            valVisible: [],
            cargandoCreados: false,
            gruposAfectadosValoracionesCreadas:[],
            afectadosValoraciones: [],
        }
    },
    methods: {
        confirmarAccionValoracion(afectado, valoracion, accion){
            this.$confirm.require({
                message: '¿Está seguro de realizar la acción?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.accionValoracion(afectado, valoracion, accion);
                },
                reject: () => {
                    return;
                }
            });
        },
        async accionValoracion(afectado, valoracion, accion){
            this.enviando = true;
            const api = new PwgsApi();
            var envio = {
                TipoOperacion:accion,
                TipoPrepVal:"V",
                IdEncargo:"",
                IdAfectado:afectado.idAfectado,
                IdPrepVal:valoracion.id_valoracion,
                Version:valoracion.version,
            }
            try{
                await api.post('servicios/' + this.id + '/accion-presuval', {envio:envio});
                if(envio.TipoOperacion == 'GEN_FACTURA'){
                    this.$toast.add({severity:'success', summary: 'Modificada', detail: 'Se ha generado el documento de la factura. En breve podrá consultarlo mediante el servicio de consulta de documentos', life: 5000});
                }else{
                    this.$toast.add({severity:'success', summary: 'Modificada', detail: 'Valoración modificada', life: 2000});
                }
                this.enviando = false;
                this.cargarTrabajos();
            }catch(e){
                this.enviando = false;
                this.$toast.add({severity: 'error', summary: 'Error', detail: e, life: 5000 });
                console.error(e);
            }
        },
        async cargarCreados(creados){
            try{
                const api = new PwgsApi();
                this.gruposAfectadosValoracionesCreadas = [];
                console.log('temporales2', creados);
                //recorremos los trabajos obtenidos (los conectados con axa, es decir que tienen parametros de env�o)
                if(creados && creados.length>0){
                    var datosValoraciones = await api.post('servicios/' + this.id + '/obtenerPresuval',  {tipo:'V'});
                }            
                creados.forEach(tempo => {      
                    //cogemos solo las valoraciones
                    if(tempo.TipoPrepVal == 'V'){                  
                        var valoracionesAxa = datosValoraciones.RepairEstimateValuationList.Valoraciones.ListadoValoraciones[0].Valoracion;          
                        //buscamos su afectado y especialidad
                        var afectadoEncontrado = this.afectadosValoraciones.find(afectado => afectado.IdAfectado == tempo.IdAfectado);
                        var especialidadEncontrada = afectadoEncontrado.Especialidades.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad && especialidad.Indice == tempo.Indice);
                        console.log('tempo', tempo);
                        tempo.TotalConIva = this.redondear(parseFloat(tempo.TotalConIva));
                        tempo.TotalSinIva = this.redondear(parseFloat(tempo.TotalSinIva));
                        var grupoAfectadoEncontrado = undefined;
                        
                        //AGRUPAMOS LOS TRABAJOS POR AFECTADO
    
                        if(especialidadEncontrada != undefined){
                            //si no hay ningun grupo de afectados, creamos uno
                            if(this.gruposAfectadosValoracionesCreadas.length == 0){
                                var grupoAfectadoTemporal = {
                                    afectado: afectadoEncontrado.NombreAfectado,
                                    idAfectado: afectadoEncontrado.IdAfectado,
                                    valoracionesCreadas: [],
                                }
                                this.gruposAfectadosValoracionesCreadas.push(grupoAfectadoTemporal);
                                grupoAfectadoEncontrado = this.gruposAfectadosValoracionesCreadas[0];
                                console.log('llegacrea');
                            }else{
                                //si hay alguno ya creado, buscamos el que corresponda
                                grupoAfectadoEncontrado = this.gruposAfectadosValoracionesCreadas.find(afectado => afectado.idAfectado == tempo.IdAfectado);
                                console.log('llegaencuentra', this.gruposAfectadosValoracionesCreadas, grupoAfectadoEncontrado);
                            }
                            // si no hay un grupo de su afectado, lo creamos
                            if(grupoAfectadoEncontrado == undefined){
                                var grupoAfectadoTemporal2 = {
                                    afectado: afectadoEncontrado.NombreAfectado,
                                    idAfectado: afectadoEncontrado.IdAfectado,
                                    valoracionesCreadas: [],
                                }
                                this.gruposAfectadosValoracionesCreadas.push(grupoAfectadoTemporal2);
                                grupoAfectadoEncontrado = this.gruposAfectadosValoracionesCreadas[this.gruposAfectadosValoracionesCreadas.length-1];
                            }
                            
                            //ya tenemos el grupo de afectado al que pertenece, ahora agrupamos de este grupo por su valoración
        
                            //si el grupo de afectado al que pertenece no tiene ninguna valoración, creamos una
                            var grupoValoracionEncontrada = undefined;
                            var valoracionAxaEncontrada = valoracionesAxa.find(valoracion => valoracion.IdPPTOVAL == tempo.id_presuval && valoracion.Version == tempo.version);                     
                            if(grupoAfectadoEncontrado.valoracionesCreadas.length == 0){   
                                var grupoValoracionCreada = {
                                    liquidar_reparador:0,
                                    liquidar_cliente:0,
                                    tiene_visita:false,
                                    tiene_desp:false,
                                    tipo_encargo:'normal',
                                    id_valoracion: tempo.id_presuval,
                                    version: tempo.version,
                                    estado: valoracionAxaEncontrada.Estado,
                                    id_estado: valoracionAxaEncontrada.IdEstado,
                                    total: valoracionAxaEncontrada.TotalPPTO,
                                    especialidades:[],
                                }
                                console.log('presuaxaenc', valoracionAxaEncontrada);
                                valoracionAxaEncontrada.Oficios.forEach(oficio => {
                                    console.log('entraoficio', oficio);
                                    if(oficio.TotalVisita != '0' && oficio.TotalVisita != '0,00'){
                                        grupoValoracionCreada.tiene_visita = true;
                                    }
                                })
    
                                if(valoracionAxaEncontrada.TipoEncargo.includes('particular')){
                                    grupoValoracionCreada.tipo_encargo = 'particular';
                                }
                                grupoAfectadoEncontrado.valoracionesCreadas.push(grupoValoracionCreada);
                                grupoValoracionEncontrada = grupoAfectadoEncontrado.valoracionesCreadas[0];
                            //si el grupo de afectado al que pertenece tiene al menos una valoración buscamos el suyo
                            }else{
                                console.log('llegaelse', grupoAfectadoEncontrado, especialidadEncontrada);
                                grupoValoracionEncontrada = grupoAfectadoEncontrado.valoracionesCreadas.find(grupo => grupo.id_valoracion == tempo.id_presuval && grupo.version == tempo.version);
                            }
        
                            //si no hay un grupo de valoracion al que pertenece, lo creamos
                            if(grupoValoracionEncontrada == undefined){                        
                                var grupoValoracionCreada2 = {
                                    liquidar_reparador:0,
                                    liquidar_cliente:0,
                                    tiene_visita:false,
                                    tiene_desp:false,
                                    tipo_encargo:'normal',
                                    id_valoracion: tempo.id_presuval,
                                    version: tempo.version,
                                    estado: valoracionAxaEncontrada.Estado,
                                    id_estado: valoracionAxaEncontrada.IdEstado,
                                    total: valoracionAxaEncontrada.TotalPPTO,
                                    especialidades:[],
                                }
                                if(valoracionAxaEncontrada.TipoEncargo.includes('particular')){
                                    grupoValoracionCreada2.tipo_encargo = 'particular';
                                }
                                valoracionAxaEncontrada.Oficios.forEach(oficio => {
                                    if(oficio.TotalVisita != '0' && oficio.TotalVisita != '0,00'){
                                        grupoValoracionCreada2.tiene_visita = true;
                                    }
                                })
                                grupoAfectadoEncontrado.valoracionesCreadas.push(grupoValoracionCreada2);
                                grupoValoracionEncontrada = grupoAfectadoEncontrado.valoracionesCreadas[grupoAfectadoEncontrado.valoracionesCreadas.length-1];
                            }
        
                            //ya tenemos el grupo de valoracion al que pertenece, ahora agrupamos de este grupo por su especialidad
        
                            //si el grupo de valoracion al que pertenece no tiene ningun grupo de especialidad, creamos uno
                            var especialidadesAxa = valoracionAxaEncontrada.Oficios;
                            console.log('especialidades', especialidadesAxa, especialidadEncontrada);
                            var especialidadAxaEncontrada = especialidadesAxa.find(especialidad => especialidad.IdEspecialidad == especialidadEncontrada.IdEspecialidad && especialidad.IndiceEspecialidad == especialidadEncontrada.Indice);
                            console.log('especialidadAxaEncontrada', especialidadAxaEncontrada);
                            if(tempo.trabajo.visita=='S' || tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                grupoValoracionEncontrada.liquidar_reparador += tempo.TotalConIva;
                            }else{
                                grupoValoracionEncontrada.liquidar_cliente += tempo.TotalConIva;
                            }
                            if(grupoValoracionEncontrada.especialidades.length == 0){                          
                                var grupoEspecialidadCreada= {
                                    especialidad: especialidadEncontrada.NombreEspecialidad,
                                    idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                    indice:especialidadEncontrada.Indice,
                                    totalBaremo:0,
                                    totalMateriales:0,
                                    totalDesplazamiento:0,
                                    totalIva:0,
                                    total:0,
                                    trabajos: [],
                                    materiales: [],
                                    desplazamiento:[],
                                    comentario: especialidadAxaEncontrada.Comentario,
                                    idProfesion: especialidadAxaEncontrada.IdProfesion,
                                };
                                if(tempo.PresupuestarPor == "BA"){
                                    grupoEspecialidadCreada.presupuestarPor = "baremo";
                                }else{
                                    grupoEspecialidadCreada.presupuestarPor = "M.O.";
                                }
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    console.log('tempotr', tempo);
                                    grupoEspecialidadCreada.totalBaremo = tempo.TotalConIva;
                                    grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                    grupoEspecialidadCreada.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                    console.log('tempomt', tempo);
                                    grupoEspecialidadCreada.totalMateriales = tempo.TotalConIva;
                                    grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                    grupoEspecialidadCreada.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada.materiales.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Desplazamiento'){
                                    console.log('tempodsp', tempo);
                                    grupoEspecialidadCreada.totalDesplazamiento = tempo.TotalConIva;
                                    grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                    grupoEspecialidadCreada.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada.desplazamiento.push(tempo);
                                }
                               
                                grupoValoracionEncontrada.especialidades.push(grupoEspecialidadCreada);
                            //Si el grupo de valoracion al que pertenece ya tiene algun grupo de epecialidad, miramos si hay un grupo para la especialidad en concreto
                            }else{
                                var grupoEncontrado = grupoValoracionEncontrada.especialidades.find(grupo => grupo.idEspecialidad == tempo.IdEspecialidad && grupo.indice == tempo.Indice);
                                //si existe el grupo de especialidad del trabajo lo a�adimos aqu�
                                if(grupoEncontrado){
                                    console.log('grupoEncontrado', grupoEncontrado);
                                    if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                        grupoEncontrado.totalBaremo = grupoEncontrado.totalBaremo+tempo.TotalConIva;
                                        grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                        grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                        grupoEncontrado.trabajos.push(tempo);
                                    }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                        grupoEncontrado.totalMateriales = grupoEncontrado.totalMateriales+tempo.TotalConIva;
                                        grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                        grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                        grupoEncontrado.materiales.push(tempo);
                                    }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                        grupoEncontrado.totalDesplazamiento = grupoEncontrado.totalDesplazamiento+tempo.TotalConIva;
                                        grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                        grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                        grupoEncontrado.desplazamiento.push(tempo);
                                    }
                                //si no existe el grupo de especialidad del trabajo lo creamos
                                }else{                            
                                    var grupoEspecialidadCreada2= {
                                        especialidad: especialidadEncontrada.NombreEspecialidad,
                                        idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                        indice:especialidadEncontrada.Indice,
                                        totalBaremo:0,
                                        totalMateriales:0,
                                        totalDesplazamiento:0,
                                        totalIva:0,
                                        total:0,
                                        trabajos: [],
                                        materiales: [],
                                        desplazamiento:[],
                                        comentario: especialidadAxaEncontrada.Comentario,
                                        idProfesion: especialidadAxaEncontrada.IdProfesion,
                                    };
                                    if(tempo.PresupuestarPor == "BA"){
                                        grupoEspecialidadCreada2.presupuestarPor = "baremo";
                                    }else{
                                        grupoEspecialidadCreada2.presupuestarPor = "M.O.";
                                    }
                                    if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                        grupoEspecialidadCreada2.totalBaremo = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                        grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.trabajos.push(tempo);
                                    }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                        grupoEspecialidadCreada2.totalMateriales = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                        grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.materiales.push(tempo);
                                    }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                        grupoEspecialidadCreada2.totalDesplazamiento = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                        grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                        grupoEspecialidadCreada2.desplazamiento.push(tempo);
                                    }
                                    grupoValoracionEncontrada.especialidades.push(grupoEspecialidadCreada2);
                                }
                            }
                        }
                    }
                    
                });
                console.log('gruposAfectadis', this.gruposAfectadosValoracionesCreadas);
                this.gruposAfectadosValoracionesCreadas.forEach(grupo => {
                    grupo.valoracionesCreadas.forEach(valoracion => {
                        console.log('valoracion', valoracion);
                        valoracion.liquidar_cliente = parseFloat(valoracion.liquidar_cliente).toFixed(2);
                        valoracion.liquidar_reparador = parseFloat(valoracion.liquidar_reparador).toFixed(2);
                        valoracion.especialidades.forEach(especialidad => {
                            especialidad.totalBaremo = parseFloat(especialidad.totalBaremo).toFixed(2);
                            especialidad.totalMateriales = parseFloat(especialidad.totalMateriales).toFixed(2);
                            especialidad.totalDesplazamiento = parseFloat(especialidad.totalDesplazamiento).toFixed(2);
                            especialidad.total = parseFloat(especialidad.total).toFixed(2);
                            especialidad.totalIva = parseFloat(especialidad.totalIva).toFixed(2);
                            if(especialidad.desplazamiento.length > 0){
                                valoracion.tiene_desp = true;
                            }
                        })
                    })
                })
            }catch(e){
                this.$toast.add({ severity: 'error', summary: "Error", detail: e, life: 5000 });
                console.error(e);
            }
            this.cargandoCreados = false;
        },
        async cargarTrabajos() {
            console.log('llegareca');
            this.cargandoCreados = true;
            const api = new PwgsApi();
            var datos = await api.post('servicios/' + this.id + '/oficios');
            var trabajos = await api.get('trabajos/'+ this.id + '/presuval-axa-val');
            if(!trabajos) trabajos = [];
            var creados = trabajos.filter(trabajo => trabajo.Enviado == 'S');
            if(datos.RepairEstimateValuationList){
                this.afectadosValoraciones = datos.RepairEstimateValuationList.Valoraciones.OficiosAfectado[0].Afectado;                
                this.cargarCreados(creados);
            }else{
                this.cargandoCreados = false;
            }
        },
        redondear(value) {
            return Number.isInteger(value)
                ? value
                : parseFloat(value.toFixed(2));
        },
    }
}
</script>